import { render, staticRenderFns } from "./target_index_new.vue?vue&type=template&id=f3ecc7a0&scoped=true"
import script from "./target_index_new.vue?vue&type=script&lang=js"
export * from "./target_index_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ecc7a0",
  null
  
)

export default component.exports